import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultCompanyContent: PageTypeContentModule = {
  pageTypeSlug: "company",
  suggestedTitles: ["About Us", "Our Story", "Company History", "Meet the Team"],
  suggestedSlugs: ["about-us", "our-story", "company", "team"],
  description: "Company information, mission, vision, and team details",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "About Our Company", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "Welcome to our company. We are dedicated to providing exceptional products and services to our customers. Our journey began with a simple mission: to deliver quality and value in everything we do.",
        },
      },
      {
        type: "header",
        data: { text: "Our Mission", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "To be the leading provider in our industry, setting standards for quality, innovation, and customer satisfaction.",
        },
      },
      {
        type: "header",
        data: { text: "Our Vision", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "To transform the industry through innovative solutions that empower our customers and create lasting value for all stakeholders.",
        },
      },
      {
        type: "header",
        data: { text: "Our Team", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Our team consists of passionate professionals dedicated to excellence. We believe in collaboration, innovation, and putting our customers first.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
